export const NAME = 'name:contains';
export const PATIENT_ID = '_id:contains';
